import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from "@angular/router";
import { AuthService } from "../services";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root'
})
export class MemberGuardService {
    private authService = inject(AuthService);


    async canActivate(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot) : Promise<boolean> {
        let user = await this.authService.getAuthUser();

        // The members claim is baked into the cached ID token at issue time, so a freshly
        // issued token can momentarily lack members that were just provisioned. Force a
        // refresh before redirecting to avoid sending members with real access to Apply Now.
        if (user?.members.length == 0 && !user.isEmployee && !user.isVendorAccountUser) {
            await this.authService.refreshSession();
            user = await this.authService.getAuthUser();
        }

        if (user?.members.length == 0 && !user.isEmployee && !user.isVendorAccountUser) {
            location.href = environment.manageAccountUrl + 'apply-now'
        }
        
        return true;   
    }
} 

export const MemberGuard: CanActivateFn = async (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) : Promise<boolean> => {
    return await inject(MemberGuardService).canActivate(next, state);
}
